import { Link } from 'react-router-dom';
import ImageSlot from './ImageSlot';

export default function Footer() {
  return (
    <footer className="relative bg-forest-900 text-cream/80 mt-0 overflow-hidden">
      {/* Decorative image strip top */}
      <div className="relative h-48 lg:h-64">
        <ImageSlot id="cta.closing" silent aspect="auto" className="absolute inset-0 h-full" />
        <div className="absolute inset-0 bg-gradient-to-t from-forest-900 via-forest-900/40 to-forest-900/10" />
        <div className="absolute inset-0 flex items-center justify-center">
          <p className="font-display italic text-cream text-2xl lg:text-4xl text-center px-6 drop-shadow-lg">
            Live in <span className="text-sand-300">harmony.</span> Naturally.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 lg:py-20 relative">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center mb-5">
              <img
                src="/image-1779155121233.png"
                alt="Costa Nativa"
                className="h-20 w-auto brightness-0 invert"
              />
            </div>
            <p className="font-display italic text-lg text-cream/80 leading-snug">
              A 160-hectare regenerative community on Costa Rica's Caribbean coast.
            </p>
            <p className="mt-5 text-sm leading-relaxed text-cream/60">
              San Clemente, Valle de la Estrella
              <br />
              Limón Province, Costa Rica
              <br />
              <a
                href="mailto:hello@costanativa.co"
                className="hover:text-papaya-300 transition-colors underline decoration-cream/30 underline-offset-4"
              >
                hello@costanativa.co
              </a>
            </p>
          </div>

          {/* Explore */}
          <div>
            <h4 className="eyebrow text-papaya-300 mb-5">Explore</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/land" className="hover:text-cream transition-colors">
                  The Land
                </Link>
              </li>
              <li>
                <Link to="/vision" className="hover:text-cream transition-colors">
                  The Vision
                </Link>
              </li>
              <li>
                <Link to="/lots" className="hover:text-cream transition-colors">
                  Masterplan
                </Link>
              </li>
              <li>
                <Link to="/lots" className="hover:text-cream transition-colors">
                  Lots &amp; Pricing
                </Link>
              </li>
            </ul>
          </div>

          {/* Tools */}
          <div>
            <h4 className="eyebrow text-papaya-300 mb-5">Tools</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/calculator" className="hover:text-cream transition-colors">
                  ROI Calculator
                </Link>
              </li>
              <li>
                <a href="#" className="hover:text-cream transition-colors">
                  Buyer Flyer
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-cream transition-colors">
                  Pitch Deck
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-cream transition-colors">
                  Founder List
                </a>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h4 className="eyebrow text-papaya-300 mb-5">Connect</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href="mailto:hello@costanativa.co"
                  className="hover:text-cream transition-colors"
                >
                  Contact
                </a>
              </li>
              <li>
                <a
                  href="https://calendar.app.google/5TmsQM5yNvGoWraz6"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-cream transition-colors"
                >
                  Schedule a visit
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-cream transition-colors">
                  Instagram
                </a>
              </li>
              <li>
                <a
                  href="https://www.costanativa.co/blog"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-cream transition-colors"
                >
                  Blog
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-cream/10 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-cream/50">
          <p>© 2026 Costa Nativa Inc. All rights reserved.</p>
          <p className="font-mono tracking-wide">
            <span className="text-papaya-300">costa</span>
            <span className="text-cream/70">nativa</span>
            <span className="text-lagoon-300">.co</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
